<script setup lang="ts">
import { defineProps, computed } from 'vue';
import { ArrivalStatus, OrderStatus } from '@/coreDomainsModule/entities/arrival';
import { i18n } from '@/i18n';

//i18n
const t = i18n.t;
/**
 * propsの定義
 */
interface Props {
  status: ArrivalStatus | OrderStatus;
  label?: string; // 表示テキストを上書きする場合に使用
}

const props = defineProps<Props>();

const text = computed(() => {
  // ArrivalStatusとOrderStatusで分岐させる
  switch (props.status) {
    case ArrivalStatus.Unpaid:
      return t('未納');
    case ArrivalStatus.ApprovalRequested || OrderStatus.ApprovalRequested:
      return t('承認依頼タグ');
    case ArrivalStatus.Recommended || OrderStatus.Recommended:
      return t('推奨タグ');
    case OrderStatus.ApprovedAwaitingDeliveryDate:
      return t('承認済');
    default:
      return '';
  }
});
</script>
<template>
  <div :class="`tag tag--${status.toLowerCase()}`">
    <div class="tag__content">
      {{ props.label ?? text }}
    </div>
  </div>
</template>
<style lang="scss" scoped>
.tag {
  min-width: 48px;
  max-width: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 90px;
  padding: 2px 26px 2px 26px;

  &--approvalrequested {
    background-color: $optionalPink;
  }
  &--recommended {
    background-color: $optionalOrange;
  }
  &--unpaid {
    background-color: $surfaceDisable;
  }
  &--approvedawaitingdeliverydate {
    background-color: $optionalViolet;
  }

  &__content {
    font-family: Noto Sans JP;
    font-size: 10px;
    line-height: 10px;
    font-weight: 700;
    letter-spacing: 0em;
    text-align: center;
    color: $semanticWhite;
  }
}
</style>
